export default "__VITE_ASSET__B9LwLBe2__"